module.exports = __webpack_public_path__ + "img/43.0d65babd.jpg";